module.exports = __webpack_public_path__ + "img/普陀.65f1e868.png";